<div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" *ngIf="avatarInfo"   >
  <wl-profile-type-icon [hidden]="isLoading" [profileId]="profileId" [isOrg]="avatarInfo.IsOrg" [isMember]="avatarInfo.IsMember"></wl-profile-type-icon>
  <wl-busy [show]="isLoading"></wl-busy>
  <a [routerLink]="['/profile', this.profileId]">{{ avatarInfo.ReportName }}</a>
</div>
